import { useState, useCallback } from "react";
import { useMsal } from "@azure/msal-react";
import { msalInstance } from "../providers/MsalProvider";
import { loginRequest } from "../auth/authConfig";
import { ErrorType, QueryError } from "../types";
import fetchMsal from "./fetchMsal";

const fetchMsalBlob = async (
  method: string,
  endpoint: string,
  data: Blob,
  _headers?: Headers
) => {
  try {
    const activeAccount = msalInstance.getActiveAccount();
    let token;
    try {
      token = (await msalInstance.acquireTokenSilent(loginRequest)).idToken;
    } catch (error) {
      await msalInstance.acquireTokenRedirect(loginRequest);
      return;
    }
    if (!activeAccount || !token) throw Error("Utilisateur non-authentifié");
    const headers = _headers ? _headers : new Headers();
    const bearer = `Bearer ${token}`;
    headers.append("Authorization", bearer);
    headers.append("Ocp-Apim-Subscription-Key", process.env.REACT_APP_APIM_SUBSCRIPTION_KEY ?? "");
    //const fullEndpoint = `${endpoint}?subscription-key=${subscriptionKey}`;

    if (data && !headers.has("Content-Type")) {
      if (!(data instanceof FormData)) {
        headers.set("Content-Type", "application/octet-stream");
      }
    }

    let options = {
      method: method,
      headers: headers,
      body: data,
    };

    return await fetchMsal(endpoint, options);

  } catch (e) {
    throw e;
  }
};

export default fetchMsalBlob;
